import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Slide from "@material-ui/core/Slide";
import Grid from "@material-ui/core/Grid";
import Chip from "@material-ui/core/Chip";

import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative"
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1
  },
  dialog: {
    position: 'absolute',
    right: 0,
    width: '80%'
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

export default function ResultDialog(props) {
  const classes = useStyles();
  
  return (
      <Dialog
        fullScreen
        open={props.open}
        onClose={props.close}
        TransitionComponent={Transition}
        classes={{
          paper: classes.dialog
        }}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={props.close}
              aria-label="close"
            >
              <ArrowBackIosIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              TOP AI &amp; Data Engineers
            </Typography>
            <Button color="inherit" variant='outlined' onClick={props.close}>
              Hire Now
            </Button>
          </Toolbar>
        </AppBar>
        <List style={{marginTop: 20, marginLeft: 20}}>
          <ListItem>
            <Typography variant="h5"  component="h4">
              <strong>{props.talent.title}</strong>
            </Typography>
          </ListItem>
          <Divider style={{marginBottom: 15}}/>
          <ListItem>
            <Typography variant="body1" color="textSecondary" component="p">
              {props.talent.description}
            </Typography>
          </ListItem>
          <Divider style={{marginBottom: 15}}/>
          <ListItem>
            <Typography variant="h6"  component="h5">
              <strong>Work History</strong>
            </Typography>
          </ListItem>
          <ListItem>
            <Grid container direction='row' justify='center' spacing={1}>
              { props.talent.experience.map((exp, index) =>
                <Grid item xs={12} key={index}>
                  <Typography variant="h6" color="textSecondary" component="h5">
                    <strong>{exp.title}</strong>
                  </Typography>
                  <Typography variant="body2" color="textSecondary" component="p">
                    {exp.from} - {exp.to}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </ListItem>
          <Divider style={{marginBottom: 15}}/>
          <ListItem>
            { props.talent.skills.map((skill, index) =>
              <Chip key={index} label={skill} style={{margin: 10}}/>
            )}
          </ListItem>
        </List>
      </Dialog>
  );
}
